import { Button } from '@/shared/ui/button'

import { type FC } from 'react'
import { List, X } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

import { useSideMenuContext } from './context'

/**
 * SideMenu.Trigger — the mobile hamburger button.
 *
 * Renders a floating fixed-positioned button visible only on mobile
 * (`<lg`). Toggling it opens/closes the drawer.
 *
 * Auto-positioned top-left on the viewport. The host application can
 * style its placement via CSS if needed (target `.side-menu-trigger`).
 */
export const SideMenuTrigger: FC = () => {
  const { isOpen, setOpen, navId } = useSideMenuContext()
  const { t } = useTranslation()

  return (
    <div className="side-menu-trigger">
      <Button
        intent="neutral"
        variant="ghost"
        size="sm"
        onClick={() => setOpen(!isOpen)}
        aria-label={isOpen ? t('sideMenu.aria.closeNavigation') : t('sideMenu.aria.openNavigation')}
        aria-expanded={isOpen}
        aria-controls={navId}
      >
        {isOpen ? <X /> : <List />}
      </Button>
    </div>
  )
}

SideMenuTrigger.displayName = 'SideMenuTrigger'
